import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { NavigationService } from '@services/nav/nav.service';

@Component({
	selector: 'app-fourohthree',
	templateUrl: './fourohthree.component.html',
	styleUrls: ['./fourohthree.component.scss'],
	standalone: false,
})
export class FourohthreeComponent {
	public ICON = ICON;

	constructor(private nav: NavigationService) {}

	public onClick() {
		this.nav.goToDashboard();
	}
}
